import { render, staticRenderFns } from "./ModalOnceAsk.vue?vue&type=template&id=02873d31&scoped=true&"
import script from "./ModalOnceAsk.vue?vue&type=script&lang=js&"
export * from "./ModalOnceAsk.vue?vue&type=script&lang=js&"
import style0 from "./ModalOnceAsk.vue?vue&type=style&index=0&id=02873d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02873d31",
  null
  
)

export default component.exports